import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/app/common";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime, label } from "@/lib/format";

const TYPES = ["all", "order", "customer", "item", "item_series", "design", "user", "role", "settings", "lookup", "lm_type", "movement_type"];
const val = (v) => (v === null || v === undefined || v === "" ? "∅" : typeof v === "object" ? JSON.stringify(v) : String(v));

export default function AdminAudit({ embedded }) {
  const [type, setType] = useState("all");
  const { data } = useFetch(`/audit-logs?limit=500${type !== "all" ? `&entity_type=${type}` : ""}`);
  return (
    <div data-testid="admin-audit-page">
      <PageHeader title={embedded ? "" : "Audit log"} subtitle="Every create, update, import, status change, approval and upload">
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-44 bg-white" data-testid="audit-type-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
        </Select>
      </PageHeader>
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="th text-left"><th className="px-3 py-2.5">When</th><th className="px-3 py-2.5">Who</th><th className="px-3 py-2.5">Record</th><th className="px-3 py-2.5">Action</th><th className="px-3 py-2.5">Detail</th></tr></thead>
          <tbody>
            {(data || []).map((a) => (
              <tr key={a.id} className="border-b border-slate-100 align-top" data-testid={`audit-row-${a.id}`}>
                <td className="px-3 py-2 text-xs font-mono whitespace-nowrap">{fmtDateTime(a.at)}</td>
                <td className="px-3 py-2 text-xs">{a.by?.name}</td>
                <td className="px-3 py-2 text-xs"><span className="uppercase text-slate-400 font-mono">{a.entity_type}</span> <span className="font-mono">{a.entity_label}</span></td>
                <td className="px-3 py-2 text-xs font-mono uppercase text-sky-700">{label(a.action)}</td>
                <td className="px-3 py-2 text-xs text-slate-600 break-all">
                  {a.note}
                  {Object.entries(a.changes || {}).map(([k, c]) => <div key={k} className="font-mono">{k}: {Array.isArray(c) ? `${val(c[0])} → ${val(c[1])}` : val(c)}</div>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
